import CustomModal from '@/components/common/CustomModal';
import LoginAuto from '@/components/common/LoginAuto';
import Redirect from '@/components/common/Redirect';
import ScrollToTop from '@/components/common/ScrollToTop';
import { useAppDispatch, useAppSelector } from '@/hooks/useReduxHooks';
import MedicalAirport from '@/pages/MedicalAirport';
import MedicalAirportGuide from '@/pages/MedicalAirportGuide';
import MedicalAirportLocation from '@/pages/MedicalCustomsLocation';
import MedicalAirportNonRefundable from '@/pages/MedicalAirportNonRefundable';
import MedicalAirportReceipt from '@/pages/MedicalAirportReceipt';
import MedicalCashPickupIntro from '@/pages/MedicalCashPickupIntro';
import MedicalCustomerRefund from '@/pages/MedicalCustomerRefund';
import MedicalDeparture from '@/pages/MedicalDeparture';
import MedicalDepartureWifi from '@/pages/MedicalDepartureWifi';
import MedicalHome from '@/pages/MedicalHome';
import MedicalKorDeparture from '@/pages/MedicalKorDeparture';
import MedicalKorDepartureLocation from '@/pages/MedicalKorDepartureLocation';
import MedicalKorUploadFile from '@/pages/MedicalKorUpload';
import MedicalKorUploadFileGuide from '@/pages/MedicalKorUploadGuide';
import MedicalLeaflet from '@/pages/MedicalLeaflet';
import MedicalPassportValidate from '@/pages/MedicalPassportValidate';
import MedicalReceipt from '@/pages/MedicalReceipt';
import PassportRedirect from '@/pages/MedicalRedirect';
import MedicalRefundInfo from '@/pages/MedicalRefundInfo';
import MedicalRefundProcedure from '@/pages/MedicalRefundProcedure';
import MedicalRefundResult from '@/pages/MedicalRefundResult';
import MedicalSelectAirport from '@/pages/MedicalSelectAirport';
import MedicalUploadFile from '@/pages/MedicalUploadFile';
import MedicalUploadTicket from '@/pages/MedicalUploadTicket';
import MedicalVerifiactionRedirect from '@/pages/MedicalVerificationRedirect';
import NotFound from '@/pages/NotFound';
import { IGlobalState } from '@/store';
import { BankCallGuideModal, CashPickupGuideModal } from '@repo/components';
import { BANK_CALL_GUIDE_MODAL, CASH_PICKUP_NATIONS } from '@repo/constants';
import { isNationIncluded, Iso639_1Code } from '@repo/utils';
import { useEffect } from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom';
import styled from 'styled-components';
import Layout from './components/common/Layout';
import { CASH_PICKUP_STORE_INTRO_BOXES } from './constant/cashPickUp.const';
import { routes } from './constant/routes.const';
import EmailPage from './pages/Inquiry/Email.page';
import FaqPage from './pages/Inquiry/Faq.page';
import PassportPage from './pages/Inquiry/Passport.page';
import QnaPage from './pages/Inquiry/Qna.page';
import MedicalDepartureCheck from './pages/MedicalDepartureCheck';
import MedicalForceTypeProcedure from './pages/MedicalForceTypeProcedure';

function RouterContainer() {
  const { nationality, homeModalInfo } = useAppSelector(
    (state) => state,
  ) as IGlobalState;
  const selectElement = document.querySelector('.goog-te-combo');
  const dispatch = useAppDispatch();

  function changeGoogleTranslateLanguage(nationality: string | null) {
    const nation = Iso639_1Code(nationality);
    if (!nation) return;
    //@ts-ignore
    selectElement.value = nation;
    //@ts-ignore
    selectElement.dispatchEvent(new Event('change'));
  }
  console.log('MEDICAL TEST1');
  useEffect(() => {
    selectElement && changeGoogleTranslateLanguage(nationality);
  }, [selectElement, nationality]);

  const onCloseModal = () => {
    dispatch({
      type: 'UPDATE_HOME_MODAL_STATE',
      payload: { isActive: false, data: null, type: null },
    });
  };

  return (
    <Container>
      <Translation id='google_translate_element'></Translation>
      <Router>
        <Redirect />
        <LoginAuto />
        <ScrollToTop />
        <Switch>
          <Layout>
            <Route
              path='/redirect/:passportNumber'
              component={PassportRedirect}
            />
            <Route
              path='/email-verification/:id/:verifiedEmail'
              component={MedicalVerifiactionRedirect}
            />
            <Route
              path={routes.medical}
              component={MedicalPassportValidate}
              exact
            />
            <Route path={routes.medicalHome} component={MedicalHome} />
            <Route path={routes.medicalReceipt} component={MedicalReceipt} />
            <Route
              path={routes.medicalDepartureCheck}
              component={MedicalDepartureCheck}
            />
            <Route path={routes.medicalAirport} component={MedicalAirport} />
            <Route
              path={routes.medicalSelectAirport}
              component={MedicalSelectAirport}
            />
            <Route
              path={routes.medicalAirportGuide}
              component={MedicalAirportGuide}
            />
            <Route
              path={routes.medicalAirportReceipt}
              component={MedicalAirportReceipt}
            />
            <Route
              path={routes.medicalAirportLocation}
              component={MedicalAirportLocation}
            />
            <Route
              path={routes.medicalAirportNonRefundable}
              component={MedicalAirportNonRefundable}
            />
            <Route
              path={routes.medicalDeparture}
              component={MedicalDeparture}
            />
            <Route
              path={routes.medicalCashPickupIntro}
              component={MedicalCashPickupIntro}
            />
            <Route
              path={routes.medicalForceTypeProcedure}
              component={MedicalForceTypeProcedure}
            />
            <Route
              path={routes.uploadKorFile}
              component={MedicalKorUploadFile}
            />
            <Route
              path={routes.medicalUploadFile}
              component={MedicalUploadFile}
            />
            <Route
              path={routes.uploadKorFileGuide}
              component={MedicalKorUploadFileGuide}
            />
            <Route
              path={routes.medicalCustomerRefund}
              component={MedicalCustomerRefund}
            />
            <Route
              path={routes.medicalRefundInfo}
              component={MedicalRefundInfo}
            />
            <Route
              path={routes.medicalRefundProcedure}
              component={MedicalRefundProcedure}
            />
            <Route
              path={routes.medicalRefundResult}
              component={MedicalRefundResult}
            />
            <Route path={routes.medicalLeaflet} component={MedicalLeaflet} />
            <Route
              path={routes.medicalKorDeparture}
              component={MedicalKorDeparture}
            />
            <Route
              path={routes.medicalKorDepartureLocation}
              component={MedicalKorDepartureLocation}
            />
            <Route
              path={routes.medicalDepartureWifi}
              component={MedicalDepartureWifi}
            />
            <Route
              path={routes.medicalUploadTicket}
              component={MedicalUploadTicket}
            />
            <Route path={routes.inquiryFaq} component={FaqPage} />
            <Route path={routes.inquiryPassport} component={PassportPage} />
            <Route path={routes.inquiryEmail} component={EmailPage} />
            <Route path={routes.inquiryQna} component={QnaPage} />
          </Layout>
          <Route>
            <NotFound />
          </Route>
        </Switch>
        {homeModalInfo?.type === 'CUSTOM' && homeModalInfo?.isActive && (
          <CustomModal onClose={onCloseModal} {...homeModalInfo?.data} />
        )}
        {isNationIncluded(CASH_PICKUP_NATIONS, nationality) &&
          homeModalInfo?.type === 'CASH_PICKUP_GUIDE' && (
            <CashPickupGuideModal
              isOpen={homeModalInfo?.type === 'CASH_PICKUP_GUIDE'}
              onClose={onCloseModal}
            />
          )}
        {(nationality === 'CHN' || nationality === 'JPN') && (
          <BankCallGuideModal
            isOpen={homeModalInfo?.type === 'BANK_INQUIRY_GUIDE'}
            title={BANK_CALL_GUIDE_MODAL[nationality].title}
            questionTitle={BANK_CALL_GUIDE_MODAL[nationality].questionTitle}
            questionText={BANK_CALL_GUIDE_MODAL[nationality].questionText}
            answerTitle={BANK_CALL_GUIDE_MODAL[nationality].answerTitle}
            answerText={BANK_CALL_GUIDE_MODAL[nationality].answerText}
            btnTitle={BANK_CALL_GUIDE_MODAL[nationality].btnTitle}
            onClick={onCloseModal}
          />
        )}
      </Router>
    </Container>
  );
}

export default RouterContainer;

const Container = styled.div`
  position: static;
`;

const Translation = styled.div`
  position: fixed;
  z-index: 200;
  @media ${(props) => props.theme.desktop} {
    right: 42%;
    top: 2px;
  }
  @media ${(props) => props.theme.mobile} {
    top: 0px;
    right: 20px;
  }
`;

const InfoTitle = styled.span`
  display: block;
  font-weight: 600;
  line-height: 150%;
  font-size: 16px;
`;
